import { render, staticRenderFns } from "./TierPrices.vue?vue&type=template&id=201a4273"
import script from "./TierPrices.vue?vue&type=script&lang=js"
export * from "./TierPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports